import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { KpiCardComponent } from '@shared/components/kpi-card/kpi-card.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { CampaignsKpiCardsStore } from './campaigns-kpi-cards.store';

@Component({
  imports: [KpiCardComponent, TranslateModule, NgxSkeletonLoaderModule],
  providers: [CampaignsKpiCardsStore],
  selector: 'app-campaigns-kpi-cards',
  templateUrl: './campaigns-kpi-cards.component.html',
})
export class CampaignsKpiCardsComponent {
  public readonly store = inject(CampaignsKpiCardsStore);

  constructor() {
    this.store.fetchCampaignsStats();
  }
}
